(function () {
  "use strict";

  var ENDPOINT = "https://isurve-event-collector.b-jgarkava.workers.dev/";

  var VISITOR_KEY = "isurve_vid";
  var SESSION_KEY = "isurve_sid";
  var SESSION_LAST_KEY = "isurve_session_last";
  var ATTR_KEY = "isurve_attribution";
  var LAST_PRODUCT_KEY = "isurve_last_product";

  var SESSION_TIMEOUT = 30 * 60 * 1000;

  /* =========================================================
     ID GENERATOR
  ========================================================= */

  function uuid() {
    try {
      return crypto.randomUUID();
    } catch (e) {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0;
          var v = c === "x" ? r : (r & 3) | 8;
          return v.toString(16);
        }
      );
    }
  }

  /* =========================================================
     SAFE STORAGE
  ========================================================= */

  function safeGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (e) {}
  }

  /* =========================================================
     VISITOR ID
     Persistent in this browser
  ========================================================= */

  function getVisitorId() {
    var id = safeGet(localStorage, VISITOR_KEY);

    if (!id) {
      id = uuid();
      safeSet(localStorage, VISITOR_KEY, id);
    }

    return id;
  }

  /* =========================================================
     SESSION ID
     New session after 30 minutes inactivity
  ========================================================= */

  function getSessionId() {
    var now = Date.now();

    var id = safeGet(localStorage, SESSION_KEY);

    var last = parseInt(
      safeGet(localStorage, SESSION_LAST_KEY) || "0",
      10
    );

    if (!id || !last || now - last > SESSION_TIMEOUT) {
      id = uuid();
      safeSet(localStorage, SESSION_KEY, id);
    }

    safeSet(
      localStorage,
      SESSION_LAST_KEY,
      String(now)
    );

    return id;
  }

  /* =========================================================
     QUERY STRING
  ========================================================= */

  function query() {
    try {
      return new URLSearchParams(location.search);
    } catch (e) {
      return new URLSearchParams();
    }
  }

  /* =========================================================
     ATTRIBUTION
     UTM / META / GOOGLE
  ========================================================= */

  function captureAttribution() {
    var q = query();
    var old = {};

    try {
      old = JSON.parse(
        safeGet(localStorage, ATTR_KEY) || "{}"
      );
    } catch (e) {}

    var fields = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",

      "fbclid",
      "gclid",

      "campaign_id",
      "adset_id",
      "ad_id"
    ];

    var found = false;

    fields.forEach(function (key) {
      var value = q.get(key);

      if (value) {
        old[key] = value;
        found = true;
      }
    });

    if (found) {
      old.landing_page = location.href;
      old.captured_at = new Date().toISOString();

      safeSet(
        localStorage,
        ATTR_KEY,
        JSON.stringify(old)
      );
    }

    return old;
  }

  function getAttribution() {
    try {
      return JSON.parse(
        safeGet(localStorage, ATTR_KEY) || "{}"
      );
    } catch (e) {
      return {};
    }
  }

  /* =========================================================
     DEVICE
  ========================================================= */

  function deviceType() {
    var ua = navigator.userAgent || "";

    if (/ipad|tablet/i.test(ua)) {
      return "tablet";
    }

    if (/mobi|android|iphone/i.test(ua)) {
      return "mobile";
    }

    return "desktop";
  }

  function browserName() {
    var ua = navigator.userAgent || "";

    if (/Edg\//.test(ua)) return "Edge";
    if (/OPR\//.test(ua)) return "Opera";
    if (/Firefox\//.test(ua)) return "Firefox";
    if (/Chrome\//.test(ua)) return "Chrome";
    if (/Safari\//.test(ua)) return "Safari";

    return "Other";
  }

  function osName() {
    var ua = navigator.userAgent || "";

    if (/Windows/i.test(ua)) return "Windows";
    if (/Android/i.test(ua)) return "Android";
    if (/iPhone|iPad|iPod/i.test(ua)) return "iOS";
    if (/Mac OS/i.test(ua)) return "macOS";
    if (/Linux/i.test(ua)) return "Linux";

    return "Other";
  }

  /* =========================================================
     INITIALIZE VISITOR + SESSION
  ========================================================= */

  var visitorId = getVisitorId();
  var sessionId = getSessionId();

  captureAttribution();

  /* =========================================================
     BASE EVENT
  ========================================================= */

  function baseEvent(type) {
    var cfg = window.ISURVE_TRACKING || {};
    var a = getAttribution();

    return {
      event_id: uuid(),
      event_time: new Date().toISOString(),

      event_type: type,

      visitor_id: visitorId,
      session_id: sessionId,

      product_id: cfg.product_id || null,
      product_handle: cfg.product_handle || null,
      product_type: cfg.product_type || null,

      collection_handle:
        cfg.collection_handle || null,

      page_type:
        cfg.page_type || "",

      page_url:
        location.href,

      page_path:
        location.pathname,

      referrer:
        document.referrer || "",

      utm_source:
        a.utm_source || "",

      utm_medium:
        a.utm_medium || "",

      utm_campaign:
        a.utm_campaign || "",

      utm_content:
        a.utm_content || "",

      utm_term:
        a.utm_term || "",

      campaign_id:
        a.campaign_id || "",

      adset_id:
        a.adset_id || "",

      ad_id:
        a.ad_id || "",

      fbclid:
        a.fbclid || "",

      gclid:
        a.gclid || "",

      device_type:
        deviceType(),

      browser:
        browserName(),

      os:
        osName()
    };
  }

  /* =========================================================
     SEND EVENT
  ========================================================= */

  function send(type, extra) {
    try {
      var event = Object.assign(
        baseEvent(type),
        extra || {}
      );

      fetch(ENDPOINT, {
        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },

        body: JSON.stringify(event),

        keepalive: true,

        credentials: "omit"
      }).catch(function () {});

    } catch (e) {}
  }

  /*
   * Public function.
   *
   * Later we'll use this for:
   * recommendations
   * product impressions
   * clicks
   * add-to-cart
   * etc.
   */

  window.isurveTrack = send;

  /* =========================================================
     PAGE VIEW
  ========================================================= */

  send("page_view");
  

var currentPath = location.pathname.replace(/\/$/, "");

if (currentPath === "/cart") {
  send("cart_view");
}
    /* =========================================================
     SEARCH QUERY
  ========================================================= */

  if (location.pathname === "/search") {
    var searchParams = query();
    var searchQuery = searchParams.get("q");

    if (searchQuery) {
      searchQuery = searchQuery.trim();

      if (searchQuery) {
        send("search", {
          search_query: searchQuery
        });
      }
    }
  }

  /* =========================================================
     PRODUCT VIEW
     + remember last viewed product
  ========================================================= */

  if (
    window.ISURVE_TRACKING &&
    window.ISURVE_TRACKING.page_type === "product" &&
    window.ISURVE_TRACKING.product_id
  ) {

    var currentProduct = {
      product_id:
        window.ISURVE_TRACKING.product_id,

      product_handle:
        window.ISURVE_TRACKING.product_handle || "",

      product_type:
        window.ISURVE_TRACKING.product_type || "",

      viewed_at:
        new Date().toISOString()
    };

    safeSet(
      localStorage,
      LAST_PRODUCT_KEY,
      JSON.stringify(currentProduct)
    );

    send("product_view");
  }

  /* =========================================================
     SUCCESSFUL LEAD
  ========================================================= */

  var successPaths = [
  "/pages/madloba",
  "/pages/thank-you-for-contacting-us",
  "/pages/gmadlobt"
];

  var currentPath =
    location.pathname.replace(/\/$/, "");

  if (
    successPaths.indexOf(currentPath) !== -1
  ) {

    var q = query();

    var sourceHandle =
      q.get("source");

    var template =
      q.get("template");

    var lastProduct = {};

    try {
      lastProduct = JSON.parse(
        safeGet(
          localStorage,
          LAST_PRODUCT_KEY
        ) || "{}"
      );
    } catch (e) {}

    /*
     * Product attribution priority:
     *
     * 1. ?source=product-handle
     * 2. Last viewed product
     */

    var conversionHandle =
      sourceHandle ||
      lastProduct.product_handle ||
      null;

    var conversionProductId =
      lastProduct.product_id ||
      null;

    var conversionProductType =
      lastProduct.product_type ||
      null;

    var attributionMethod =
      sourceHandle
        ? "url_source"
        : (
            lastProduct.product_handle
              ? "last_product"
              : "unknown"
          );

    send(
      "lead_success",
      {
        product_id:
          conversionProductId,

        product_handle:
          conversionHandle,

        product_type:
          conversionProductType,

        lead_type:
          template || "",

        metadata: {
          attribution_method:
            attributionMethod,

          source_handle:
            sourceHandle || "",

          last_product_handle:
            lastProduct.product_handle || "",

          last_product_viewed_at:
            lastProduct.viewed_at || "",

          template:
            template || ""
        }
      }
    );
  }

  /* =========================================================
     PRODUCT ENGAGEMENT / DWELL TIME
  ========================================================= */

  var visibleStarted =
    document.hidden
      ? null
      : Date.now();

  var visibleMs = 0;

  var engagementSent = false;

  document.addEventListener(
    "visibilitychange",
    function () {

      if (document.hidden) {

        if (visibleStarted !== null) {

          visibleMs +=
            Date.now() - visibleStarted;

          visibleStarted = null;
        }

      } else {

        visibleStarted =
          Date.now();
      }
    }
  );

  function sendEngagement() {

    if (engagementSent) {
      return;
    }

    if (visibleStarted !== null) {

      visibleMs +=
        Date.now() - visibleStarted;

      visibleStarted = null;
    }

    if (
      window.ISURVE_TRACKING &&
      window.ISURVE_TRACKING.page_type === "product" &&
      window.ISURVE_TRACKING.product_id &&
      visibleMs >= 1000
    ) {

      engagementSent = true;

      send(
        "product_engagement",
        {
          duration_ms:
            Math.round(visibleMs)
        }
      );
    }
  }

  window.addEventListener(
    "pagehide",
    sendEngagement
  );
  /* =========================================================
     PRODUCT CARD IMPRESSIONS + CLICKS
  ========================================================= */

  var CARD_SELECTOR =
    '.grid-view-item[id^="ProductCard-"]';

  var impressedCards = new Set();
  var cardTimers = new WeakMap();

  function getCardData(card) {

    if (!card) return null;

    var id = card.id || "";

    var productId = null;
    var placement = "unknown";

    /*
     * RELATED PRODUCTS
     * ProductCard-related-products-6676345290822
     */
    var match =
      id.match(
        /^ProductCard-related-products-(\d+)$/
      );

    if (match) {
      productId = match[1];
      placement = "related_products";
    }

    /*
     * COLLECTION
     * ProductCard-collection-template-7132332458054
     */
    if (!productId) {

      match =
        id.match(
          /^ProductCard-collection-template-(\d+)$/
        );

      if (match) {
        productId = match[1];
        placement = "collection";
      }
    }

    /*
     * FALLBACK
     * For other ProductCard-* formats
     */
    if (!productId) {

      match = id.match(/(\d+)$/);

      if (match) {
        productId = match[1];
      }
    }

    var link =
      card.querySelector(
        'a[href*="/products/"]'
      );

    if (!link) return null;

    var productHandle = null;

    try {

      var url =
        new URL(
          link.href,
          location.origin
        );

      var handleMatch =
        url.pathname.match(
          /\/products\/([^/?#]+)/
        );

      if (handleMatch) {
        productHandle =
          decodeURIComponent(
            handleMatch[1]
          );
      }

    } catch (e) {}

    if (!productHandle) {
      return null;
    }

    /*
     * CARD POSITION
     */

    var position = null;

    var gridItem =
      card.closest(".grid__item");

    if (
      gridItem &&
      gridItem.parentElement
    ) {

      var siblings =
        Array.prototype.filter.call(
          gridItem.parentElement.children,
          function (el) {

            return (
              el.querySelector &&
              el.querySelector(
                CARD_SELECTOR
              )
            );

          }
        );

      var index =
        siblings.indexOf(gridItem);

      if (index !== -1) {
        position = index + 1;
      }
    }

    return {
      product_id: productId,
      product_handle: productHandle,
      placement: placement,
      position: position
    };
  }


  /* =========================================================
     IMPRESSION OBSERVER

     Count impression only when:
     - at least 50% of card is visible
     - for at least 500 milliseconds
     - once per product/placement per page load
  ========================================================= */

  var cardObserver =
    new IntersectionObserver(
      function (entries) {

        entries.forEach(
          function (entry) {

            var card = entry.target;

            if (
              entry.isIntersecting &&
              entry.intersectionRatio >= 0.5
            ) {

              if (
                cardTimers.has(card)
              ) {
                return;
              }

              var timer =
                setTimeout(
                  function () {

                    cardTimers.delete(card);

                    /*
                     * Re-check visibility after 500ms.
                     */
                    var rect =
                      card.getBoundingClientRect();

                    var viewportHeight =
                      window.innerHeight ||
                      document.documentElement.clientHeight;

                    var visibleTop =
                      Math.max(
                        rect.top,
                        0
                      );

                    var visibleBottom =
                      Math.min(
                        rect.bottom,
                        viewportHeight
                      );

                    var visibleHeight =
                      Math.max(
                        0,
                        visibleBottom -
                        visibleTop
                      );

                    var ratio =
                      rect.height > 0
                        ? visibleHeight /
                          rect.height
                        : 0;

                    if (ratio < 0.5) {
                      return;
                    }

                    var data =
                      getCardData(card);

                    if (!data) {
                      return;
                    }

                    var key =
                      data.placement +
                      ":" +
                      data.product_id;

                    if (
                      impressedCards.has(key)
                    ) {
                      return;
                    }

                    impressedCards.add(key);

                    send(
                      "product_impression",
                      {
                        product_id:
                          data.product_id,

                        product_handle:
                          data.product_handle,

                        placement:
                          data.placement,

                        position:
                          data.position
                      }
                    );

                  },
                  500
                );

              cardTimers.set(
                card,
                timer
              );

            } else {

              var existingTimer =
                cardTimers.get(card);

              if (existingTimer) {

                clearTimeout(
                  existingTimer
                );

                cardTimers.delete(card);
              }
            }
          }
        );
      },
      {
        threshold: [0, 0.5, 1]
      }
    );


  /* =========================================================
     REGISTER PRODUCT CARDS
  ========================================================= */

  function observeProductCards(root) {

    if (!root) return;

    /*
     * Root itself may be a card.
     */
    if (
      root.matches &&
      root.matches(CARD_SELECTOR)
    ) {

      if (
        root.getAttribute(
          "data-isurve-observed"
        ) !== "1"
      ) {

        root.setAttribute(
          "data-isurve-observed",
          "1"
        );

        cardObserver.observe(root);
      }
    }

    /*
     * Cards inside root.
     */
    if (!root.querySelectorAll) {
      return;
    }

    var cards =
      root.querySelectorAll(
        CARD_SELECTOR
      );

    Array.prototype.forEach.call(
      cards,
      function (card) {

        if (
          card.getAttribute(
            "data-isurve-observed"
          ) === "1"
        ) {
          return;
        }

        card.setAttribute(
          "data-isurve-observed",
          "1"
        );

        cardObserver.observe(card);
      }
    );
  }

  observeProductCards(document);


  /* =========================================================
     PRODUCT CARD CLICK
  ========================================================= */

  document.addEventListener(
    "click",
    function (event) {

      var target = event.target;

      if (!target) return;

      var link =
        target.closest
          ? target.closest(
              '.grid-view-item[id^="ProductCard-"] a[href*="/products/"]'
            )
          : null;

      if (!link) {
        return;
      }

      var card =
        link.closest(
          CARD_SELECTOR
        );

      var data =
        getCardData(card);

      if (!data) {
        return;
      }

      send(
        "product_click",
        {
          product_id:
            data.product_id,

          product_handle:
            data.product_handle,

          placement:
            data.placement,

          position:
            data.position
        }
      );

    },
    true
  );


  /* =========================================================
     DYNAMIC / AJAX PRODUCT CARDS
  ========================================================= */

  var cardMutationObserver =
    new MutationObserver(
      function (mutations) {

        mutations.forEach(
          function (mutation) {

            Array.prototype.forEach.call(
              mutation.addedNodes,
              function (node) {

                if (
                  node.nodeType !== 1
                ) {
                  return;
                }

                observeProductCards(node);
              }
            );
          }
        );
      }
    );

  if (document.body) {

    cardMutationObserver.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

})();